import React, { useState } from 'react';
import { createPayroll } from '../../services/adminService';

const MESES = [
  { id: '01', label: 'Enero' },
  { id: '02', label: 'Febrero' },
  { id: '03', label: 'Marzo' },
  { id: '04', label: 'Abril' },
  { id: '05', label: 'Mayo' },
  { id: '06', label: 'Junio' },
  { id: '07', label: 'Julio' },
  { id: '08', label: 'Agosto' },
  { id: '09', label: 'Septiembre' },
  { id: '10', label: 'Octubre' },
  { id: '11', label: 'Noviembre' },
  { id: '12', label: 'Diciembre' },
];

const anios = () => {
  const actual = new Date().getFullYear();
  const lista = [];

  for (let anio = actual - 1; anio <= actual + 1; anio += 1) {
    lista.push(String(anio));
  }

  return lista;
};

const NominaCrear = ({ sessionId, onSalir }) => {
  const hoy = new Date();
  const [quincena, setQuincena] = useState(hoy.getDate() <= 15 ? '1' : '2');
  const [mes, setMes] = useState(String(hoy.getMonth() + 1).padStart(2, '0'));
  const [anio, setAnio] = useState(String(hoy.getFullYear()));
  const [omitidas, setOmitidas] = useState([]);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState('');

  const crear = () => {
    if (!quincena || !mes || !anio) {
      setError('Selecciona la quincena, el mes y el año.');
      setAviso('');
      return;
    }

    setGuardando(true);
    setError('');
    setAviso('');
    setOmitidas([]);

    createPayroll(sessionId, { quincena, mes, anio })
      .then((datos) => {
        const nuevas = datos.creadas || [];
        const fuera = datos.omitidas || [];

        setOmitidas(fuera);

        if (nuevas.length > 0) {
          setAviso('Nómina creada.');
        } else if (fuera.length === 0) {
          setAviso('Esta quincena ya incluye a quien corresponde.');
        } else {
          setAviso('No se creó ninguna nómina.');
        }
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudo crear la nómina.');
      })
      .finally(() => {
        setGuardando(false);
      });
  };

  return (
    <div className="admin-pre-overlay" role="presentation">
      <div className="admin-pre-panel nomina-crear-panel" role="dialog" aria-modal="true">
        <div className="admin-pre-bar">
          <h2>Crear nómina</h2>
          <button type="button" className="admin-pre-close" onClick={onSalir} aria-label="Cerrar">
            ×
          </button>
        </div>
        <p className="admin-muted">
          Solo entra el personal fijo. No se crea quien no está activo, no tiene tipo de nómina, tiene el
          salario en 0 o todavía no ha ingresado. Si la quincena ya existe, solo se agregan quienes faltan.
          Una quincena cerrada no se vuelve a generar.
        </p>
        {error ? (
          <div className="admin-alert admin-alert--error" role="alert">
            {error}
          </div>
        ) : null}
        {aviso ? (
          <div className="admin-alert admin-alert--success" role="status">
            {aviso}
          </div>
        ) : null}
        <div className="admin-form-row">
          <label className="admin-field">
            <span>Quincena</span>
            <select value={quincena} onChange={(event) => setQuincena(event.target.value)}>
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          </label>
          <label className="admin-field">
            <span>Mes</span>
            <select value={mes} onChange={(event) => setMes(event.target.value)}>
              {MESES.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.label}
                </option>
              ))}
            </select>
          </label>
          <label className="admin-field">
            <span>Año</span>
            <select value={anio} onChange={(event) => setAnio(event.target.value)}>
              {anios().map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="admin-pre-actions">
          <button type="button" className="admin-btn admin-btn--primary" onClick={crear} disabled={guardando}>
            {guardando ? 'Creando…' : 'Crear nómina'}
          </button>
          <button type="button" className="admin-btn admin-btn--secondary" onClick={onSalir}>
            Salir
          </button>
        </div>
        {omitidas.length > 0 ? (
          <div className="admin-alert admin-alert--error" role="alert">
            {omitidas.map((fila, indice) => (
              <p key={fila.nombre + indice}>
                {fila.nombre} no se creó: {fila.motivo}
              </p>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default NominaCrear;
